import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/SayAlt.module_built.css";
const classes = {"say-alt":"w6N4Cvq_say-alt"}
export default classes

const _say_alt0 = classes["say-alt"]
export { _say_alt0 as "say-alt" }
